import * as categoriesActions from '../actions/categories.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface CategoriesState {
    categories: any;
    loading: boolean;
    loaded: boolean;
}

const initialState = {
    categories: null,
    loading: false,
    loaded: false
};

export const categoriesReducer = (state = initialState, action) => {
    switch(action.type){
        case categoriesActions.GET_CATEGORIES_LIST:
            return {
                ...state,
                loading: true,
                loaded: state.loaded
            };
        case categoriesActions.GET_CATEGORIES_LIST_SUCCESS:
            return {
                ...state,
                categories: action.payload,
                loading: false,
                loaded: true,
            };
        case categoriesActions.GET_CATEGORIES_LIST_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
                loaded: false
            };
        case categoriesActions.CLEAR_CATEGORIES_LIST:
            return {
                ...state,
                error: null,
                categories: null,
                loading: false,
                loaded: false
            };
        default:
            return state;
    }
};

export const getCategoriesState = createFeatureSelector<CategoriesState>('categoriesReducer');

export const getCategoriesList = (state: CategoriesState) => state.categories;
export const getCategoriesListLoaded = (state: CategoriesState) => state.loaded;
export const getCategoriesListLoading = (state: CategoriesState) => state.loaded;
